import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "CampaignEditorRow"
}
const _hoisted_2 = { class: "TableEntitiesColumnS ColumnAlignCenter" }
const _hoisted_3 = ["checked", "title", "disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "TableEntitiesColumnS ColumnAlignCenter" }
const _hoisted_6 = ["checked", "onClick", "title", "disabled"]
const _hoisted_7 = { class: "TableEntitiesColumnXL" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "TableEntitiesColumnM ColumnAlignCenter" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "TableEntitiesColumnL ColumnAlignCenter" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "TableEntitiesColumnM ColumnAlignCenter" }
const _hoisted_14 = { class: "EntityIdIndicator" }
const _hoisted_15 = {
  key: 1,
  class: "CampaignEditorRow CampaignEditorText NoStudiesOrganisationsMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			'LargeLoadingContent',
			!_ctx.isLoading ? 'TableLinkedStudiesOrganisationsWrapper' : ''
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      (_ctx.filteredEntities.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_2, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "TableEntitiesCheckbox",
                    checked: _ctx.areAllEntitiesAttached,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAllEntitiesCheckboxClicked && _ctx.onAllEntitiesCheckboxClicked(...args))),
                    title: _ctx.checkboxTitle,
                    disabled: _ctx.hasCampaignFinished
                  }, null, 8 /* PROPS */, _hoisted_3)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("th", { class: "TableEntitiesColumnXL" }, " Name ", -1 /* CACHED */)),
                _cache[2] || (_cache[2] = _createElementVNode("th", { class: "TableEntitiesColumnM ColumnAlignCenter" }, " Status ", -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createElementVNode("th", { class: "TableEntitiesColumnL ColumnAlignCenter" }, " Degree level ", -1 /* CACHED */)),
                _cache[4] || (_cache[4] = _createElementVNode("th", { class: "TableEntitiesColumnM ColumnAlignCenter" }, " ID ", -1 /* CACHED */))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEntities, (entity) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: entity.id
                }, [
                  (!_ctx.isParentHidden(entity))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                        _createElementVNode("td", _hoisted_5, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "TableEntitiesCheckbox",
                            checked: entity.attached,
                            onClick: ($event: any) => (_ctx.onEntityAttachedStatusChanged($event, entity)),
                            title: _ctx.checkboxTitle,
                            disabled: _ctx.hasCampaignFinished
                          }, null, 8 /* PROPS */, _hoisted_6)
                        ]),
                        _createElementVNode("td", _hoisted_7, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.retrieveNameStylingClassNameForEntity(entity)),
                            onClick: ($event: any) => (_ctx.toggleVisibilityOfChildrenOfEntity(entity))
                          }, _toDisplayString(entity.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_8)
                        ]),
                        _createElementVNode("td", _hoisted_9, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
								'EntityPremiumnessIndicator',
								_ctx.retrievePremiumnessStylingClassNameForEntity(entity)
							]),
                            title: _ctx.retrievePremiumnessFullNameForEntity(entity)
                          }, _toDisplayString(_ctx.retrievePremiumnessAbbreviatedNameForEntity(entity)), 11 /* TEXT, CLASS, PROPS */, _hoisted_10)
                        ]),
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("span", {
                            class: "EntityDegreeLevelIndicator",
                            title: _ctx.retrieveDegreeLevelFullNameForEntity(entity)
                          }, _toDisplayString(_ctx.retrieveDegreeLevelAbbreviatedNameForEntity(entity)), 9 /* TEXT, PROPS */, _hoisted_12)
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(entity.id), 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, " No organisation was linked "))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading"]))
}